exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inactivity-message[data-v-3c92c23c] {\n  min-width: 550px;\n  max-width: 550px;\n}\n.inactivity-message__popup h2[data-v-3c92c23c] {\n  margin: 0 0 12px;\n}\n.inactivity-message__popup p[data-v-3c92c23c] {\n  margin: 0 0 22px;\n}\n.inactivity-message__buttons[data-v-3c92c23c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.inactivity-message__buttons button[data-v-3c92c23c] {\n    -webkit-box-flex: .25;\n        -ms-flex: .25;\n            flex: .25;\n}\n.inactivity-message__buttons button[data-v-3c92c23c]:first-child {\n      margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c92c23c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/common/messages/InactivityMessage.vue
// module id = Bj/y
// module chunks = 1